/* eslint-disable */

import throttle from 'lodash.throttle';
import HomepageAnim from './modules/anim/HomepageAnim';
import 'requestidlecallback';
import { setTheme } from './modules/anim/themes';

//
//   Global App Variable
//
// ////////////////////////////////////////////////////////////////////

const isHome =
  typeof window.entry !== 'undefined' &&
  typeof window.entry.section !== 'undefined' &&
  window.entry.section === 'home';

if(isHome){
  document.body.classList.add('homepage');
}

window.APP = {
  devMode: typeof window.devMode !== 'undefined' ? window.devMode : true,
  isHome: isHome,
  mouseX: window.innerWidth / 2,
  mouseY: window.innerHeight / 2,
  winWidth: window.innerWidth,
  mqMedium: 768,
  mqLarge: 1024,
  reducedMotion: false,

  settings: {
    // BG Related
    bgMaxReach: 1.3,
    bgEase: isHome ? 0.01 : 0.005,
    bgOscAmp: 200,
    bgOscPeriod: 1200,
  },

  isMqSmall: () => APP.winWidth < APP.mqMedium,
  isMqMedium: () => APP.winWidth < APP.mqLarge,
};

//   App Initiation
//
// ////////////////////////////////////////////////////////////////////

APP.init = function() {
  const readyPromises = [];

  if (APP.devMode) {
    const guiPromise = import(/* webpackChunkName: "gui" */ '@malven/gui')
      .then(({ default: Gui }) => {
        APP.gui = new Gui();
        APP.gui.connectMidiRange(0, 15);

        // Global settings
        APP.gui.setFolder('BG');
        APP.gui.add(APP.settings, 'bgMaxReach', 0.0001, 2.0);
        APP.gui.add(APP.settings, 'bgEase', 0.0001, 0.2);
        APP.gui.add(APP.settings, 'bgOscAmp', 0, 1000);
        APP.gui.add(APP.settings, 'bgOscPeriod', 10, 5000);

        // Close the gui
        APP.gui.hide();
      })
      .catch(error => 'An error occurred while loading the the GUI module.');
    readyPromises.push(guiPromise);
  }

  // Set the theme
  setTheme('black');

  // Kickoff
  Promise.all(readyPromises).then(() => {
    requestIdleCallback(
      () => {
        const homepageAnim = new HomepageAnim();
        const readyEvent = new CustomEvent('animationReady', {
          detail: {
            homepageAnim,
          },
        });
        document.dispatchEvent(readyEvent);
      },
      { timeout: 5000 }
    );
  });

  // Resize
  const _onResize = evt => {
    APP.winWidth = window.innerWidth;
  };
  window.addEventListener('resize', throttle(_onResize, 100));

  // Handling touch
  window.isTouch = false;
  window.addEventListener('touchstart', () => {
    window.isTouch = true;
    document.getElementsByTagName('html')[0].classList.add('is-touch');
  });

  // Global mouse movement listener
  const _onMove = evt => {
    if (APP.isMqMedium() || window.isTouch) {
      APP.mouseX = window.innerWidth / 2;
      APP.mouseY = window.innerHeight / 2;
    } else {
      APP.mouseX = evt.pageX;
      APP.mouseY = evt.pageY - window.scrollY;
    }
  };
  document.addEventListener('mousemove', _onMove, false);

  // Reduced motion
  const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const updateReducedMotion = () => {
    APP.reducedMotion = mediaQuery.matches;
  };
  mediaQuery.addEventListener('change', updateReducedMotion);

  updateReducedMotion();
};

//
//   Kickoff
//
// ////////////////////////////////////////////////////////////////////

APP.init();
